<template>
<div class="chapter">
<div class="inner_page">
<div id="TOC">
<h1>CONTENTS</h1>
<h3 class="left" id="introduction"><span class="sans"><a href="#/005introduction">INTRODUCTION</a></span></h3>
<h3 class="left" id="ch1"><span class="sans"><a href="#/006chapter1">CHAPTER 1 AMERICAN CHICKEN</a></span></h3>
<blockquote>
<p class="noindent" id="hh1"><span class="sans"><a href="#/006chapter1#chh1">CRISPY ROAST CHICKEN</a></span></p>
<p class="noindent">with Watercress Vinaigerette, Corriander Green Beans, and Wild Rice</p>
<p class="noindent" id="hh2"><span class="sans"><a href="#/006chapter1#chh2">“BACON” CHICKEN WITH FRESH HERBS</a></span></p>
<p class="noindent">Grilled Summer Vegetables, and Hobo Corn</p>
<p class="noindent" id="hh3"><span class="sans"><a href="#/006chapter1#chh3">BRICKHOUSE CHICKEN</a></span></p>
<p class="noindent">over Orzo with Tossed Greens</p>
<p class="noindent" id="hh4"><span class="sans"><a href="#/006chapter1#chh4">OVEN-FRIED CHICKEN</a></span></p>
<p class="noindent">with Roasted Yams and Raddish–Mint Salad</p>
<p class="noindent" id="hh5"><span class="sans"><a href="#/006chapter1#chh5">LEMON CHICKEN</a></span></p>
<p class="noindent">with Crispy Sage Leaves, Creamy Polenta, and Roasted Fennel</p>
<p class="noindent" id="hh6"><span class="sans"><a href="#/006chapter1#chh6">SPRING FARMERS’ MARKET MEAL:</a></span></p>
<p class="noindent">Green Garlic Chicken with Golden Beets and Fava Bean Salad</p>
<p class="noindent" id="hh7"><span class="sans"><a href="#/006chapter1#chh7">EDNA LEWIS-INSPIRED FRIED THIGHS</a></span></p>
<p class="noindent">with Horseradish–Green Bean Potato Salad and Buttermilk Corn Bread</p>
<p class="noindent" id="hh8"><span class="sans"><a href="#/006chapter1#chh8">GRILLED THIGHS WITH BLISTERED BBQ SAUCE,</a></span></p>
<p class="noindent">Purple Slaw and Cheddar Biscuits</p>
<p class="noindent" id="hh9"><span class="sans"><a href="#/006chapter1#chh9">CHICKEN PIE</a></span></p>
<p class="noindent">with Pickled Beets</p>
<p class="noindent" id="hh10"><span class="sans"><a href="#/006chapter1#chh10">CHICKEN-FENNEL MEATBALLS</a></span></p>
<p class="noindent">on Angel Hair with Fresh Tomato Sauce and Endive–Apple Salad</p>
</blockquote>
<h3 class="left" id="ch2"><span class="sans"><a href="#/007chapter2">CHAPTER 2 BISTRO CHICKEN</a></span></h3>
<blockquote>
<p class="noindent" id="hh11"><span class="sans"><a href="#/007chapter2#chh11">SLOW-SAUTÉED THIGHS</a></span></p>
<p class="noindent">with French Lentils and Endive Salad</p>
<p class="noindent" id="hh12"><span class="sans"><a href="#/007chapter2#chh12">TUSCAN THIGHS</a></span></p>
<p class="noindent">with Wild Mushroom Risotto and Brussels Sprouts Ribbons</p>
<p class="noindent" id="hh13"><span class="sans"><a href="#/007chapter2#chh13">POULET DUXELLES OVER JASMINE RICE</a></span></p>
<p class="noindent">with Confetti Peas and Carrots</p>
<p class="noindent" id="hh14"><span class="sans"><a href="#/007chapter2#chh14">HERBE POULE AU POT</a></span></p>
<p class="noindent">with Mustard Seed–Potato Gratin and Frisée–Apple Salad</p>
<p class="noindent" id="hh15"><span class="sans"><a href="#/007chapter2#chh15">SORREL CHICKEN TROISGROS</a></span></p>
<p class="noindent">with Purée of Peas</p>
<p class="noindent" id="hh16"><span class="sans"><a href="#/007chapter2#chh16">CHANTERELLE CHICKEN</a></span></p>
<p class="noindent">over Egg Noodles with Sautéed Asparagus</p>
<p class="noindent" id="hh17"><span class="sans"><a href="#/007chapter2#chh17">TARRAGON CHICKEN</a></span></p>
<p class="noindent">with Shell Beans and Acini di Pepe</p>
<p class="noindent" id="hh18"><span class="sans"><a href="#/007chapter2#chh18">TRIPLE-MUSTARD CRUSTED CHICKEN</a></span></p>
<p class="noindent">with Fingerling Potatoes and Satsuma–Fennel Salad</p>
<p class="noindent" id="hh19"><span class="sans"><a href="#/007chapter2#chh19">TRUFFLED ROAST CHICKEN</a></span></p>
<p class="noindent">with Glazed Chervil Carrots and Riced Potatoes</p>
<p class="noindent" id="hh20"><span class="sans"><a href="#/007chapter2#chh20">COLD ROAST CHICKEN</a></span></p>
<p class="noindent">with Artichokes, Roasted Potatoes, and Romaine Hearts with Herb Aioli</p>
</blockquote>
<h3 class="left" id="ch3"><span class="sans"><a href="#/008chapter3">CHAPTER 3 LATIN CHICKEN</a></span></h3>
<blockquote>
<p class="noindent" id="hh21"><span class="sans"><a href="#/008chapter3#chh21">STUFFED ANAHEIM CHILES</a></span></p>
<p class="noindent">with Red Rice and Rainbow Salsa</p>
<p class="noindent" id="hh22"><span class="sans"><a href="#/008chapter3#chh22">ARROZ CON POLLO</a></span></p>
<p class="noindent">with Raw Hot Sauce, Orange–Carrot Slaw, and Salty–Sweet Fried Bananas</p>
<p class="noindent" id="hh23"><span class="sans"><a href="#/008chapter3#chh23">CHICKEN POSOLE</a></span></p>
<p class="noindent">with Fried Tortillas, Tomatillo Salsa, and Cilantro Cream</p>
<p class="noindent" id="hh24"><span class="sans"><a href="#/008chapter3#chh24">ROADSIDE CHICKEN TACOS</a></span></p>
<p class="noindent">with Black Bean–Quinoa Salad and Fresh Corn Relish</p>
<p class="noindent" id="hh25"><span class="sans"><a href="#/008chapter3#chh25">CHICKEN-GOAT CHEESE ENCHILADAS</a></span></p>
<p class="noindent">with Lime–Cilantro Succotash and Black Beans</p>
<p class="noindent" id="hh26"><span class="sans"><a href="#/008chapter3#chh26">JERK THIGHS</a></span></p>
<p class="noindent">with Jamaican Peas and Watermelon Salad</p>
<p class="noindent" id="hh27"><span class="sans"><a href="#/008chapter3#chh27">ROAST CHICKEN WITH KUMQUATS,</a></span></p>
<p class="noindent">Spicy Butternut Squash, and Cilantro Rice</p>
<p class="noindent" id="hh28"><span class="sans"><a href="#/008chapter3#chh28">SPICY ROAST CHICKEN</a></span></p>
<p class="noindent">with Arepas, Avocado Butter, and Blackened Peppers</p>
</blockquote>
<h3 class="left" id="ch4"><span class="sans"><a href="#/009chapter4">CHAPTER 4 EAST ASIAN CHICKEN</a></span></h3>
<blockquote>
<p class="noindent" id="hh29"><span class="sans"><a href="#/009chapter4#chh29">CRISPY CHICKEN SALAD</a></span></p>
<p class="noindent" id="hh30"><span class="sans"><a href="#/009chapter4#chh30">CHIANG MAI GREEN CURRY</a></span></p>
<p class="noindent" id="hh31"><span class="sans"><a href="#/009chapter4#chh31">LEMONGRASS CHICKEN STIR-FRY</a></span></p>
<p class="noindent" id="hh32"><span class="sans"><a href="#/009chapter4#chh32">SUMO WRESTLER STEW (<em>CHANKONABE</em>)</a></span></p>
<p class="noindent" id="hh33"><span class="sans"><a href="#/009chapter4#chh33">SICHUAN CHICKEN HOT POT</a></span></p>
<p class="noindent" id="hh34"><span class="sans"><a href="#/009chapter4#chh34">ONE-POT COCONUT CHICKEN</a></span></p>
<p class="noindent">over Jasmine Rice</p>
<p class="noindent" id="hh35"><span class="sans"><a href="#/009chapter4#chh35">BLACK SOY THIGHS</a></span></p>
<p class="noindent">with Shell Beans and Coconut Rice</p>
<p class="noindent" id="hh36"><span class="sans"><a href="#/009chapter4#chh36">KOREAN FRIED CHICKEN</a></span></p>
<p class="noindent">with Sweey–and–Spicy Sauce, Roasted Shishito Pepers, and Black Sesame Rice Balls</p>
<p class="noindent" id="hh37"><span class="sans"><a href="#/009chapter4#chh37">GAI YANG</a></span></p>
<p class="noindent">with Bird’s–Eye Chili Dipping Sauce and Watermelon–Cucumber Salad</p>
<p class="noindent" id="hh38"><span class="sans"><a href="#/009chapter4#chh38">PHUKET BEACH CART SANDWICHES</a></span></p>
<p class="noindent">with Sambal Mayonnaise and Carrot–Mung Bean Salad</p>
</blockquote>
<h3 class="left" id="ch5"><span class="sans"><a href="#/010chapter5">CHAPTER 5 SOUTH ASIAN CHICKEN</a></span></h3>
<blockquote>
<p class="noindent" id="hh39"><span class="sans"><a href="#/010chapter5#chh39">CHANA DAL WITH CHICKEN</a></span></p>
<p class="noindent" id="hh40"><span class="sans"><a href="#/010chapter5#chh40">CHICKEN-VEGETABLE KADHI</a></span></p>
<p class="noindent">with Chickpea Cakes and Yogurt–Mint Sauce</p>
<p class="noindent" id="hh41"><span class="sans"><a href="#/010chapter5#chh41">CHICKEN ADOBO</a></span></p>
<p class="noindent">with Grilled Pattypan Squash</p>
<p class="noindent" id="hh42"><span class="sans"><a href="#/010chapter5#chh42">MULLIGATAWNY WITH APPLE</a></span></p>
<p class="noindent">and Onion Flatbread</p>
<p class="noindent" id="hh43"><span class="sans"><a href="#/010chapter5#chh43">CURRIED CHICKEN</a></span></p>
<p class="noindent">with Fried Okra and Mixed Condiments</p>
<p class="noindent" id="hh44"><span class="sans"><a href="#/010chapter5#chh44">CHICKEN-CASHEW CURRY</a></span></p>
<p class="noindent">over Basmati Rice with Mustard Carrot Ribbons</p>
<p class="noindent" id="hh45"><span class="sans"><a href="#/010chapter5#chh45">NEPALESE GUESTHOUSE CHICKEN</a></span></p>
<p class="noindent">with Tea–Scented Lentils and Minted Yogurt</p>
<p class="noindent" id="hh46"><span class="sans"><a href="#/010chapter5#chh46">GINGER-CORIANDER CHICKEN</a></span></p>
<p class="noindent">with Roasted Cauliflower</p>
</blockquote>
<h3 class="left" id="ch6"><span class="sans"><a href="#/011chapter6">CHAPTER 6 MIDDLE EASTERN AND AFRICAN CHICKEN</a></span></h3>
<blockquote>
<p class="noindent" id="hh47"><span class="sans"><a href="#/011chapter6#chh47">BEDOUIN STEW</a></span></p>
<p class="noindent">with Fresh Garlic Chickpeas and Tomato Relish</p>
<p class="noindent" id="hh48"><span class="sans"><a href="#/011chapter6#chh48">PIRI PIRI KUKU</a></span></p>
<p class="noindent">with Chopped Greens and Toasted Millet</p>
<p class="noindent" id="hh49"><span class="sans"><a href="#/011chapter6#chh49">GRILLED THIGHS</a></span></p>
<p class="noindent">with Blackened Stone–Fruit Relish, Saffron Rice, and Frozen Pickled Cucumbers</p>
<p class="noindent" id="hh50"><span class="sans"><a href="#/011chapter6#chh50">CHICKEN THIGHS WITH HARISSA,</a></span></p>
<p class="noindent">Blistered Sweet Peppers, and Peanut–Mustard Green Beans</p>
<p class="noindent" id="hh51"><span class="sans"><a href="#/011chapter6#chh51">CHICKEN IN PARCHMENT WITH FIGS</a></span></p>
<p class="noindent">and Lemon–Pistachio Barley</p>
<p class="noindent" id="hh52"><span class="sans"><a href="#/011chapter6#chh52">PRESERVED LEMON CHICKEN WITH OLIVES</a></span></p>
<p class="noindent">Almond Couscous, and Herb Yogurt Cheese</p>
<p class="noindent" id="hh53"><span class="sans"><a href="#/011chapter6#chh53">SAFFRON CHICKEN WITH CHICKPEAS,</a></span></p>
<p class="noindent">Fez Couscous, and Roasted Eggplant</p>
<p class="noindent" id="hh54"><span class="sans"><a href="#/011chapter6#chh54">SENGALESE CHICKEN</a></span></p>
<p class="noindent">with Black–Eyed Peas and Avocado–Zucchini Relish</p>
</blockquote>
<h3 class="left" id="index"><span class="sans"><a href="#/012index">INDEX</a></span></h3>
<div class="image" id="image3">
<p class="center"><img alt="pots and dishes" src="images/image-2.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004-toc.vue?0b2c7edd